// extracted by mini-css-extract-plugin
export default {"container":"RecordCompareArrayGroup_container__xKAcC","read-only-checkbox":"RecordCompareArrayGroup_read-only-checkbox__aqS+r"};